import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 15",
	fill: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M12 0a1 1 0 00-1 1v1H5V1a1 1 0 00-2 0v1h-.6C1.1 2 0 3 0 4.4V5h16v-.6C16 3.1 15 2 13.6 2H13V1c0-.6-.4-1-1-1z" }), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M0 6v6.7C0 14 1 15 2.4 15h11.2c1.3 0 2.4-1 2.4-2.3V6H0zm5 3a1 1 0 11-2 0 1 1 0 012 0zm3 1a1 1 0 100-2 1 1 0 000 2zm5-1a1 1 0 11-2 0 1 1 0 012 0zm-1 4a1 1 0 100-2 1 1 0 000 2zm-3-1a1 1 0 11-2 0 1 1 0 012 0zm-5 1a1 1 0 100-2 1 1 0 000 2z"
	})]
});
export default SvgCalendar;
